
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayDigitalClosedRight as ObiThreewayDigitalClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-digital-closed-right.js';
 
 
 

 
 export const ObiThreewayDigitalClosedRight = createComponent({
   react: React,
   tagName: 'obi-threeway-digital-closed-right',
   elementClass: ObiThreewayDigitalClosedRightElement,
   events: {
     
   }
  });
 
 